import React, { useState } from 'react';

export function useSortableTableData(data) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return data;
    const sorted = [...data].sort((a, b) => {
      if (a[sortConfig.key] === undefined || b[sortConfig.key] === undefined) return 0;
      // Special handling for 'amount' column: parse as float
      if (sortConfig.key.toLowerCase() === 'amount') {
        const aNum = parseFloat(String(a[sortConfig.key]).replace(/[^\d.-]/g, ''));
        const bNum = parseFloat(String(b[sortConfig.key]).replace(/[^\d.-]/g, ''));
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
      }
      if (typeof a[sortConfig.key] === 'number' && typeof b[sortConfig.key] === 'number') {
        return sortConfig.direction === 'asc'
          ? a[sortConfig.key] - b[sortConfig.key]
          : b[sortConfig.key] - a[sortConfig.key];
      }
      // Compare as strings
      const aVal = String(a[sortConfig.key]).toLowerCase();
      const bVal = String(b[sortConfig.key]).toLowerCase();
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [data, sortConfig]);

  const handleSort = (colName) => {
    setSortConfig((prev) => {
      if (prev.key === colName) {
        if (prev.direction === 'asc') {
          return { key: colName, direction: 'desc' };
        } else if (prev.direction === 'desc') {
          // Third click: reset sort
          return { key: null, direction: null };
        }
      }
      return { key: colName, direction: 'asc' };
    });
  };

  return { sortedData, sortConfig, handleSort };
}